(() => {
  const SELECTOR = '[data-la-mobile-nav]';

  function initMobileNav(nav) {
    if (!nav || nav.dataset.laNavReady === 'true') return;
    nav.dataset.laNavReady = 'true';

    const rootPanel = nav.querySelector('[data-la-nav-root]');
    const openButtons = Array.from(nav.querySelectorAll('[data-la-nav-open]'));
    const submenuPanels = Array.from(nav.querySelectorAll('[data-la-nav-panel]'));
    const backButtons = Array.from(nav.querySelectorAll('[data-la-nav-back]'));
    const quoteOpenButtons = Array.from(nav.querySelectorAll('[data-la-bespoke-quote-open]'));
    const quoteModal = nav.querySelector('[data-la-bespoke-quote-modal]');
    const quoteCloseButton = nav.querySelector('[data-la-bespoke-quote-close]');
    const quoteFrame = nav.querySelector('[data-la-bespoke-quote-frame]');
    const quoteLoading = nav.querySelector('[data-la-bespoke-quote-loading]');

    let lastTrigger = null;
    let lastQuoteTrigger = null;

    function resetPanels({ restoreFocus = false } = {}) {
      nav.classList.remove('la-mobile-nav--submenu-open');

      openButtons.forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });

      submenuPanels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });

      if (rootPanel) {
        rootPanel.setAttribute('aria-hidden', 'false');
        rootPanel.scrollTop = 0;
      }

      if (restoreFocus && lastTrigger && nav.getAttribute('aria-hidden') === 'false') {
        window.requestAnimationFrame(() => lastTrigger.focus());
      }
    }

    function openPanel(button) {
      const panelId = button.getAttribute('data-la-nav-open');
      const target = panelId ? nav.querySelector('#' + CSS.escape(panelId)) : null;
      if (!target) return;

      lastTrigger = button;

      openButtons.forEach((item) => {
        item.setAttribute('aria-expanded', item === button ? 'true' : 'false');
      });

      submenuPanels.forEach((panel) => {
        const active = panel === target;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      if (rootPanel) rootPanel.setAttribute('aria-hidden', 'true');

      nav.classList.add('la-mobile-nav--submenu-open');
      target.scrollTop = 0;

      const back = target.querySelector('[data-la-nav-back]');
      if (back) window.requestAnimationFrame(() => back.focus());
    }

    openButtons.forEach((button) => {
      button.addEventListener('click', () => openPanel(button));
    });

    backButtons.forEach((button) => {
      button.addEventListener('click', () => resetPanels({ restoreFocus: true }));
    });

    function openQuoteModal(trigger) {
      if (!quoteModal) return;

      lastQuoteTrigger = trigger || null;
      quoteModal.hidden = false;
      quoteModal.setAttribute('aria-hidden', 'false');
      nav.classList.add('la-mobile-nav--quote-open');

      if (quoteFrame && !quoteFrame.getAttribute('src')) {
        const src = quoteFrame.getAttribute('data-src');
        if (src) quoteFrame.setAttribute('src', src);
      }

      window.requestAnimationFrame(() => {
        if (quoteCloseButton) quoteCloseButton.focus();
      });
    }

    function closeQuoteModal({ restoreFocus = true } = {}) {
      if (!quoteModal || quoteModal.hidden) return;

      quoteModal.hidden = true;
      quoteModal.setAttribute('aria-hidden', 'true');
      nav.classList.remove('la-mobile-nav--quote-open');

      if (restoreFocus && lastQuoteTrigger && nav.getAttribute('aria-hidden') === 'false') {
        window.requestAnimationFrame(() => lastQuoteTrigger.focus());
      }
    }

    quoteOpenButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openQuoteModal(button);
      });
    });

    if (quoteCloseButton) {
      quoteCloseButton.addEventListener('click', () => closeQuoteModal());
    }

    if (quoteFrame) {
      quoteFrame.addEventListener('load', () => {
        const frameWrap = quoteFrame.closest('.la-mobile-nav__quote-frame-wrap');
        if (frameWrap) frameWrap.classList.add('is-loaded');
        if (quoteLoading) quoteLoading.setAttribute('aria-hidden', 'true');
      });
    }

    nav.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && quoteModal && !quoteModal.hidden) {
        event.preventDefault();
        closeQuoteModal();
      }
    });

    const observer = new MutationObserver(() => {
      if (nav.getAttribute('aria-hidden') === 'true') {
        closeQuoteModal({ restoreFocus: false });
        resetPanels();
      }
    });

    observer.observe(nav, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initMobileNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();